import classNames from "classnames";
import { SelfServePageData } from "../fetcher";
import Image from "components/imageNew/image";

type BenefitsProps = {
  data: SelfServePageData;
};

export const Benefits = ({ data }: BenefitsProps) => {
  if (data.benefits.length === 0) return null;
  return (
    <div>
      <p className="mb-[30px] mt-[70px] font-recklessBold text-[32px] leading-[130%]">
        {data.benefitsHeading}
      </p>
      <div className="flex flex-col gap-y-[30px]">
        {data.benefits.map((item, i) => {
          const isOdd = i % 2 === 0;
          const isEven = i % 2 !== 0;

          return (
            <div
              key={i}
              className={classNames("flex flex-col", {
                "md:flex-row": isOdd,
                "md:flex-row-reverse": isEven,
              })}
            >
              <div
                className={classNames("flex", {
                  "max-md:w-full md:ml-[20px] lg:ml-[60px]": isEven,
                  "md:mr-[20px] lg:mr-[60px]": isOdd,
                })}
              >
                <Image
                  alt={`Sifted for Angels Benefit ${i + 1}`}
                  src={item.image.url}
                  width={item.image.width}
                  height={item.image.height}
                  className="object-cover max-md:w-full md:max-h-[180px] md:max-w-[270px] lg:max-h-[225px] lg:max-w-[400px]"
                />
              </div>
              <div className="flex w-full flex-col justify-center">
                <h3 className="mt-1 font-recklessBold text-[26px] leading-[130%] md:mt-0">
                  {item.title}
                </h3>
                <p className="mt-4 text-[18px] leading-[130%]">
                  {item.subtitle}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
